<template>
  <section>
    <div class="titulo">
      <div class="margem container">
        <!-- Download de relatório -->
        <div title="Clique para baixar o aplicativo" class="m-icone direita">
          <a href="https://drive.google.com/file/d/1wuaCaIZalghqvqPo3csqEiQH437qFZee/view?usp=sharing" target="_blank">
            <div class="icone-download-apk" style="transform: scale(1.5)"></div>
          </a>
        </div>
        <h2>Monitor de {{ isTabActive("tab1") ? "bateria" : "acelerômetro" }}</h2>
      </div>
    </div>

    <div class="margem">
      <div class="margem container bloco">
        <div class="linha alinha-v">
          <div class="m-icone">
            <a href="/" class="icone-arrow-back"></a>
          </div>
          <div class="tags">
            <a class="titulo" :class="isTabActive('tab1') ? 'ativo' : ''" @click="changeTab('tab1')">Bateria</a>
            <a class="titulo" :class="isTabActive('tab2') ? 'ativo' : ''" @click="changeTab('tab2')">Acelerômetro</a>
          </div>
          <div style="display: flex; flex-direction: column; place-items: end; margin-left: auto">
            <div class="fonte-fraca">Dispositivo</div>
            <h3 v-if="device">id {{ device.id }} - {{ device.brand }} {{ device.model }}</h3>
            <span v-if="device && device.online !== null" :class="device.online ? 'status-online' : 'status-offline'">
              {{ device.online ? "Online" : "Offline" }}
            </span>
          </div>
        </div>

        <!-- Loading -->
        <div v-if="isLoading" class="loading">
          <div></div>
        </div>

        <div v-if="!isLoading">
          <div v-show="isTabActive('tab1')">
            <BateriaView />
          </div>
          <div v-show="isTabActive('tab2')">
            <AcelerometroView />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import AcelerometroView from "./AcelerometroView.vue";
import BateriaView from "./BateriaView.vue";
import DeviceDataSource from "@/data/datasource/DeviceDataSource";
import { getDispositivoStorageKey } from "@/utils/dispositivo-storage";

const repo = new DeviceDataSource();

export default {
  data() {
    return {
      activeTab: "tab1",
      device: null,
      isLoading: true,
    };
  },
  components: {
    AcelerometroView,
    BateriaView,
  },
  methods: {
    isTabActive(tab) {
      return tab === this.activeTab;
    },
    changeTab(tab) {
      this.activeTab = tab;
    },
    async loadDeviceDetails() {
      const storageKey = getDispositivoStorageKey();
      const raw = sessionStorage.getItem(storageKey);
      const stored = raw ? JSON.parse(raw) : null;

      if (!stored || !stored.id) {
        this.$router.push("/");
        return;
      }

      try {
        // Busca detalhes completos do dispositivo
        this.device = await repo.getDeviceDetails(stored.id);
        // Atualiza sessionStorage com dados completos
        sessionStorage.setItem(storageKey, JSON.stringify(this.device));
      } catch (error) {
        console.error("Erro ao buscar detalhes do dispositivo:", error);
        this.$router.push("/");
      }

      this.isLoading = false;
    },
  },
  created() {
    this.loadDeviceDetails();
  },
};
</script>

<style scoped>
.tags {
  cursor: pointer;
}

.status-online {
  color: #22c55e;
  font-weight: bold;
  font-size: 14px;
}

.status-offline {
  color: #9ca3af;
  font-size: 14px;
}
</style>
